// File: src/components/UploadModal.js
import React, { useState } from 'react';
import { X, Search } from 'lucide-react';

const FileItem = ({ name, size, date, onAddToPipeline }) => (
  <div className="flex items-center justify-between p-3 border rounded-md">
    <div className="flex items-center space-x-3">
      <div className="text-gray-500">📄</div>
      <div>
        <div className="font-medium">{name}</div>
        <div className="text-sm text-gray-500">{size} • {date}</div>
      </div>
    </div>
    <button 
      onClick={onAddToPipeline}
      className="text-blue-500 hover:text-blue-600"
    >
      Add to Pipeline
    </button>
  </div>
);

const UploadModal = ({ isOpen, onClose, onFileUpload }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  if (!isOpen) return null;
  
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      onFileUpload(file);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center backdrop-blur-sm z-50 transition-opacity duration-300">
      <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 w-[600px] shadow-2xl border border-gray-100 transform transition-all duration-300">
        {/* Header with enhanced styling */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">Manage Uploads</h2>
          <button 
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>
        
        {/* Search and upload section */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex-1 mr-4">
            <div className="flex items-center border rounded-lg p-2 bg-white shadow-sm hover:shadow-md transition-shadow duration-200">
              <Search size={16} className="text-gray-400 mr-2" />
              <input 
                type="text" 
                placeholder="Search" 
                className="flex-1 outline-none"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <label className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2.5 rounded-lg cursor-pointer shadow-md hover:shadow-lg transition-all duration-200">
            Upload File
            <input 
              type="file" 
              className="hidden" 
              accept=".csv,.xlsx,.xls"
              onChange={handleFileUpload}
            />
          </label>
        </div>

        {/* Files list with styled scrollbar */}
        <div className="max-h-[400px] overflow-y-auto rounded-xl bg-white shadow-inner p-3">
          <style jsx>{`
            .custom-scrollbar::-webkit-scrollbar {
              width: 6px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
              background: #f8fafc;
              border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background: #cbd5e1;
              border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background: #94a3b8;
            }
          `}</style>
          
          <div className="space-y-3 custom-scrollbar pr-2">
            <FileItem 
              name="LendingClub Data.csv" 
              size="15.69 MB" 
              date="2024-11-25" 
            />
            <FileItem 
              name="cyber attack training data" 
              size="1.38 MB" 
              date="2024-11-22" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;